// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const ComponentSpacerFragmentDoc = gql`
    fragment componentSpacer on ComponentSpacer {
  __typename
  spacing
}
    `;